<template>
  <div class="d-flex flex-row mb-6 align-self-center flex-wrap">
    <div ref="svg" style="width:50px; margin: 5px" class="align-self-center">
      No icon
    </div>
    <div class="align-self-center">
      <v-btn @click="showPicker = true" color="primary">{{
        $t("components.iconpicker.choose")
      }}</v-btn>
    </div>
    <v-dialog v-model="showPicker" scrollable>
      <material-card
        :title="$t('components.iconpicker.pick_icon')"
        icon="toggle_on"
        :color="$vuetify.theme.themes.light.success"
      >
        <v-card-text>
          <edit-icons
            v-if="showPicker"
            ref="editIcons"
            :selectedIcon.sync="selectedIcon"
          ></edit-icons>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="!selectedIcon"
            color="primary"
            @click="
              $emit('update:icon', selectedIcon);
              showPicker = false;
            "
            >{{ $t("globals.save") }}</v-btn
          >
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
import EditIcons from "../components/EditIcons";
export default {
  components: {
    EditIcons,
  },
  props:{
      icon: Object
  },
  data: () => ({
    selectedIcon: undefined,
    showPicker: false,
  }),
  mounted() {
    this.$refs.svg.innerHTML = this.$t("components.portal.image_picker.no_icon");
  },
  watch: {
    icon: {
      immediate: true,
      handler() {
        if (!this.$refs.svg) return;
        this.$nextTick(function() {
          if (this.icon) this.$refs.svg.innerHTML = this.icon.Svg;
          else this.$refs.svg.innerHTML = this.$t("components.portal.image_picker.no_icon");
        });
      },
    },
  },
};
</script>
